import React from "react";
import AttOnly from "../../img/AttOnlyInd.png";
import ZombieKiller from "../../img/ZombieKillerInd.png";
// import AreaAtt from "../../img/AreaAttInd.png";
// import AttBuff from "../../img/AttBuffInd.png";
import BarrierBreaker from "../../img/BarrierBreakerInd.png";
import BaseDest from "../../img/BaseInd.png";
// import CostDown from "../../img/CostDownInd.png";
import Critical from "../../img/CriticalInd.png";
// import DefBuff from "../../img/DefBuffInd.png";
import ExtraMoney from "../../img/ExtraMoneyInd.png";
import Freeze from "../../img/FreezeInd.png";
// import ImpKnockback from "../../img/ImpKnockbackInd.png";
import InsaneDmg from "../../img/InsaneDmgInd.png";
import InsanelyTough from "../../img/InsanelyToughInd.png";
import Knockback from "../../img/KnockbackInd.png";
import SurgeAttacks from "../../img/SurgeAttInd.png";
// import LessEffCurse from "../../img/LessEffCurseInd.png";
// import LessEffFreeze from "../../img/LessEffFreezeInd.png";
// import LessEffKnockback from "../../img/LessEffKnockbackInd.png";
// import LessEffResist from "../../img/LessEffResistInd.png";
// import LessEffSlow from "../../img/LessEffSlowInd.png";
// import LessEffWarp from "../../img/LessEffWarpInd.png";
// import LessEffWave from "../../img/LessEffWaveInd.png";
import LongDist from "../../img/LongDistInd.png";
import MassiveDmg from "../../img/MassiveDmgInd.png";
import Metal from "../../img/MetalInd.png";
import Multihit from "../../img/MultiHitInd.png";
// import MoveSpdUp from "../../img/MoveSpdUpInd.png";
import Omnistrike from "../../img/OmniStrikeInd.png";
// import RecoverSpdUp from "../../img/RecoverSpdUpInd.png";
import Resistant from "../../img/ResistantInd.png";
import ResistCurse from "../../img/ResistCurseInd.png";
import ResistFreeze from "../../img/ResistFreezeInd.png";
import ResistKnockback from "../../img/ResistKnockbackInd.png";
import ResistSlow from "../../img/ResistSlowInd.png";
import ResistWarp from "../../img/ResistWarpInd.png";
import ResistWeaken from "../../img/ResistWeakenInd.png";
// import SingleAtt from "../../img/SingleAttInd.png";
import Slow from "../../img/SlowInd.png";
import Strengthen from "../../img/StrengthenInd.png";
import StrongAgainst from "../../img/StrongAgainstInd.png";
import Survive from "../../img/SurviveInd.png";
import UnharmedWaves from "../../img/UnharmWavesInd.png";
// import Warp from "../../img/WarpInd.png";
import WaveAtt from "../../img/WaveAttInd.png";
import WaveShield from "../../img/WaveShieldInd.png";
import Weaken from "../../img/WeakenInd.png";
import Dodge from "../../img/DodgeInd.png";
import Curse from "../../img/CurseInd.png";
import SavageBlow from "../../img/SavageBlowInd.png";
import MiniWave from "../../img/MiniWaveInd.png";
import ApostleKiller from "../../img/ApostleKillerInd.png";
import EvadeSurge from "../../img/EvadeSurgeInd.png";
import ShieldPiercing from "../../img/ShieldPiercingInd.png";
import ColossusSlayer from "../../img/ColossusSlayerInd.png";
import BehemothSlayer from "../../img/BehemothSlayerInd.png";

const abilitylist = [
  {
    text: "Strong",
    value: "Strong",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={StrongAgainst}
        alt="Strong Against"
        placeholder="Strong Against"
      />
    ),
  },
  {
    text: "Resistant",
    value: "Resistant",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Resistant}
        placeholder="Resistant"
        alt="Resistant"
      />
    ),
  },
  {
    text: "Insanely Tough",
    value: "Insanely Tough",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={InsanelyTough}
        placeholder="Insanely Tough"
        alt="Insanely Tough"
      />
    ),
  },
  {
    text: "Massive Damage",
    value: "Massive Damage",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={MassiveDmg}
        placeholder="Massive Damage"
        alt="Massive Damage"
      />
    ),
  },
  {
    text: "Insane Damage",
    value: "Insane Damage",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={InsaneDmg}
        placeholder="Insane Damage"
        alt="Insane Damage"
      />
    ),
  },
  {
    text: "Long Distance",
    value: "Long Distance",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={LongDist}
        placeholder="Long Distance"
        alt="Long Distance"
      />
    ),
  },
  {
    text: "Slow",
    value: "to slow",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Slow}
        placeholder="Slow"
        alt="Slow"
      />
    ),
  },
  {
    text: "Knockback",
    value: "of knockback",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Knockback}
        placeholder="Knockback"
        alt="Knockback"
      />
    ),
  },
  {
    text: "Freeze",
    value: "to freeze",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Freeze}
        placeholder="Freeze"
        alt="Freeze"
      />
    ),
  },
  {
    text: "Weaken",
    value: "to weaken",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Weaken}
        placeholder="Weaken"
        alt="Weaken"
      />
    ),
  },
  {
    text: "Survive",
    value: "Survive",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Survive}
        placeholder="Survive"
        alt="Survive"
      />
    ),
  },
  {
    text: "Is Metal",
    value: "Only takes 1",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Metal}
        placeholder="Metal"
        alt="Metal"
      />
    ),
  },
  {
    text: "Base Destroyer",
    value: "Base Destroyer",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={BaseDest}
        placeholder="Base Destroyer"
        alt="Base Destroyer"
      />
    ),
  },
  {
    text: "Extra Money",
    value: "money gained",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={ExtraMoney}
        placeholder="Extra Money"
        alt="Extra Money"
      />
    ),
  },
  {
    text: "Critical",
    value: "Critical",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Critical}
        placeholder="Critical"
        alt="Critical"
      />
    ),
  },
  {
    text: "Zombie Killer",
    value: "Zombie Killer",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={ZombieKiller}
        placeholder="Zombie Killer"
        alt="Zombie Killer"
      />
    ),
  },
  {
    text: "Omni Strike",
    value: "Omni Strike",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Omnistrike}
        placeholder="Omnistrike"
        alt="Omnistrike"
      />
    ),
  },
  {
    text: "Wave Attack",
    value: "Wave attack",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={WaveAtt}
        placeholder="Wave Attack"
        alt="Wave Attack"
      />
    ),
  },
  {
    text: "Wave Shield",
    value: "Wave Shield",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={WaveShield}
        placeholder="Wave Shield"
        alt="Wave Shield"
      />
    ),
  },
  {
    text: "Attacks Only",
    value: "Attacks only",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={AttOnly}
        placeholder="Attacks Only"
        alt="Attacks Only"
      />
    ),
  },

  {
    text: "Strengthen",
    value: "Strengthen",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Strengthen}
        placeholder="Strengthen"
        alt="Strengthen"
      />
    ),
  },
  {
    text: "Multi-hit Attack",
    value: "Multi-hit",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Multihit}
        placeholder="Multi-hit"
        alt="Multi-hit"
      />
    ),
  },

  {
    text: "Resist Freeze",
    value: "Not(.*Freeze)",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={ResistFreeze}
        placeholder="Resist Freeze"
        alt="Resist Freeze"
      />
    ),
  },
  {
    text: "Resist Slow",
    value: "Not(.*Slow)",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={ResistSlow}
        placeholder="Resist Slow"
        alt="Resist Slow"
      />
    ),
  },
  {
    text: "Resist Weaken",
    value: "Not(.*Weaken)",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={ResistWeaken}
        placeholder="Resist Weaken"
        alt="Resist Weaken"
      />
    ),
  },
  {
    text: "Resist Knockback",
    value: "Not(.*Knockback)",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={ResistKnockback}
        placeholder="Resist Knockback"
        alt="Resist Knockback"
      />
    ),
  },
  {
    text: "Unharmed by Waves",
    value: "Not(.*Wave)",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={UnharmedWaves}
        placeholder="Unharmed by Waves"
        alt="Unharmed by Waves"
      />
    ),
  },
  {
    text: "Resist Curse",
    value: "Not(.*Curse)",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={ResistCurse}
        placeholder="Resist Curse"
        alt="Resist Curse"
      />
    ),
  },
  {
    text: "Warp Blocker",
    value: "Not(.*Warp)",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={ResistWarp}
        placeholder="Warp Blocker"
        alt="Warp Blocker"
      />
    ),
  },
  {
    text: "Barrier Breaker",
    value: "Barrier Breaker",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={BarrierBreaker}
        placeholder="Barrier Breaker"
        alt="Barrier Breaker"
      />
    ),
  },
  {
    text: "Dodge",
    value: "Dodge",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Dodge}
        placeholder="Dodge"
        alt="Dodge"
      />
    ),
  },
  {
    text: "Curse",
    value: "to curse",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={Curse}
        placeholder="Curse"
        alt="Curse"
      />
    ),
  },
  {
    text: "Surge Attacks",
    value: "Surge Attacks",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={SurgeAttacks}
        placeholder="Surge Attacks"
        alt="Surge Attacks"
      />
    ),
  },
  {
    text: "Savage Blow",
    value: "Savage Blow",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={SavageBlow}
        placeholder="Savage Blow"
        alt="Savage Blow"
      />
    ),
  },
  {
    text: "Mini-Wave",
    value: "Mini-Wave",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={MiniWave}
        placeholder="Mini-Wave"
        alt="Mini-Wave"
      />
    ),
  },
  {
    text: "Eva Angel Killer",
    value: "Eva Angel Killer",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={ApostleKiller}
        placeholder="Eva Angel Killer"
        alt="Eva Angel Killer"
      />
    ),
  },
  {
    text: "Evade Surge",
    value: "Not(.*Surge)",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={EvadeSurge}
        placeholder="Evade Surge"
        alt="Evade Surge"
      />
    ),
  },
  {
    text: "Shield Piercing",
    value: "Shield Piercing",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={ShieldPiercing}
        placeholder="Shield Piercing"
        alt="Shield Piercing"
      />
    ),
  },
  {
    text: "Colossus Slayer",
    value: "Colossus Slayer",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={ColossusSlayer}
        placeholder="Colossus Slayer"
        alt="Colossus Slayer"
      />
    ),
  },
  {
    text: "Behemoth Slayer",
    value: "Behemoth Slayer",
    img: (
      <img
        style={{ width: "24px", height: "24px" }}
        src={BehemothSlayer}
        placeholder="Behemoth Slayer"
        alt="Behemoth Slayer"
      />
    ),
  },
];

export default abilitylist;



// WEBPACK FOOTER //
// ./src/components/utilities/abilitylist.js